
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Spätestens seit den Veröffentlichungen des Historikers Roger Ekirch von der Virginia Tech University – ein erster Aufsatz erschien 2001 – weiss man, dass der heute in Mitteleuropa übliche Schlaf in einem Block nur ein Modell der Nachtruhe ist. Ekirch hatte Hunderte Quellen aus vorindustrieller Zeit zwischen 1500 und 1750 erschlossen und festgestellt, dass die Europäer damals meist in zwei Phasen schliefen, unterbrochen von einer ein- bis zweistündigen Pause, die für alles Mögliche genutzt wurde: Essen und Plaudern, Gebete und Sex. `}<M mdxType="M">{`Oder sie statteten mitten in der Nacht den Nachbarn einen kurzen Besuch ab, um sich danach wieder zurückzuziehen und weiterzuschlafen.`}</M>{` Erst die Gaslampen und die Glühbirnen hätten diese Praxis beendet, die Menschen gingen dadurch nicht mehr so früh ins Bett. Zudem: In der präindustriellen Ära galt die Nacht als Satans Spielzeit. Gute Leute, so der Glaube, seien nachts müde von der verrichteten Arbeit und blieben daher in ihren Betten. Über die Jahrhunderte entwickelte sich so der heute übliche Tagesablauf, der seine Plausibilität nicht zuletzt seinem zahlenmystischen Charme verdankt: 8-8-8. Je acht Stunden Arbeit, Freizeit, Schlaf.`}<br /><br />{`
Das biphasische Muster wurde in vielen indigenen, präelektrischen Gesellschaften gefunden. Dennoch bleibt fraglich, ob Roger Ekirch das Ur-Schlafmuster gefunden hat. So gibt es mittlerweile auch ethnologische Studien über präindustrielle Völker, die ähnlich wie Mitteleuropäer knapp sechs bis sieben Stunden in einem Block schlafen`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;